'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React from 'react'

import type { SiteSetting, Header } from '@payload-types'

import { Logo } from '@/components/logo'
import { HeaderNav } from './nav'
import { CurrencyTicker } from './currency-ticker'
import { MobileMenu } from '@/payload/globals/header/mobile-menu'
import { SearchIcon } from 'lucide-react'

interface LogoData {
  src: string
  width: number
  height: number
  alt: string
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
}

interface HeaderClientProps {
  data: Header
  logoData: LogoData
  siteName: string
}

export const HeaderClient: React.FC<HeaderClientProps> = ({ data, logoData, siteName }) => {
  const pathname = usePathname()
  return (
    <header className="container relative p-4 z-20 max-w-6xl mx-auto">
      <div className="grid grid-cols-12 gap-4">
        <CurrencyTicker data={data} />
      </div>

      {/* Mobile Header */}
      <div className="md:hidden flex items-center justify-between py-2">
        <Link href="/" className="flex items-center">
          <Logo loading="eager" {...logoData} />
        </Link>
        <div className="flex items-center gap-2">
          <Link href="/arama" className="text-foreground flex items-center gap-2 ml-2">
            <SearchIcon className="w-5 md:w-6" />
            <span className="text-sm md:text-base text-muted-foreground hidden md:inline">
              Ara...
            </span>
          </Link>
          <MobileMenu data={data} />
        </div>
      </div>

      {/* Desktop Header */}
      <div className="hidden md:grid grid-cols-12 gap-4">
        <Link href="/" className="col-span-1 flex items-center">
          <Logo loading="eager" {...logoData} />
        </Link>
        <div className="flex flex-col col-span-11">
          {/*           <SpecialNav data={data} />
          <Separator className="my-1" /> */}
          <HeaderNav data={data} />
        </div>
      </div>
    </header>
  )
}

/*      <div className="py-8 flex justify-between">
        <Link href="/">
          <Logo loading="eager" priority="high" className="invert dark:invert-0" />
        </Link>
        <HeaderNav data={data} />
      </div>
      
*/
